import React from "react";
import IntroBody from "../component/home/introBody";
import LatestBlogMobile from "../component/home/LatestBlogMobile";
import Footer from "../../component/Footer";

class IntroMobile extends React.Component {
  render() {
    return (
      <div>
        <IntroBody />
        <LatestBlogMobile />
        <Footer />
      </div>
    );
  }
}

export default IntroMobile;
